// employeeNotificationActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AssignNotificationPayload,
  MarkAsReadPayload,
  GetEmployeeNotificationsPayload,
  NotificationEntry
} from './employeeNotificationTypes';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Assign Notification to Employee
export const assignNotification = createAsyncThunk(
  'employeeNotification/assign',
  async (data: AssignNotificationPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/employee-notification/assign', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to assign notification');
    }
  }
);

// Mark Notification as Read
export const markNotificationAsRead = createAsyncThunk(
  'employeeNotification/markAsRead',
  async (data: MarkAsReadPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/employee-notification/mark-as-read', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to mark notification as read');
    }
  }
);

// Get All Notifications for an Employee
export const fetchEmployeeNotifications = createAsyncThunk<
  NotificationEntry[],
  GetEmployeeNotificationsPayload,
  { rejectValue: string }
>(
  'employeeNotification/fetchAll',
  async ({ employeeId }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/employee-notification/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch notifications');
    }
  }
);
